const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

const CUTOFFS: Array<[number, Intl.RelativeTimeFormatUnit]> = [
  [60, "second"],
  [3600, "minute"],
  [86400, "hour"],
  [86400 * 7, "day"],
  [86400 * 30, "week"],
  [86400 * 365, "month"],
  [Infinity, "year"],
];

export function formatRelativeDate(dateStr: string): string {
  const date = new Date(dateStr);
  const diffMs = date.getTime() - Date.now();
  const diffSec = Math.round(diffMs / 1000);
  const absDiff = Math.abs(diffSec);

  for (let i = 0; i < CUTOFFS.length; i++) {
    const [cutoff, unit] = CUTOFFS[i] as [(typeof CUTOFFS)[0][0], (typeof CUTOFFS)[0][1]];
    const prevCutoff = i > 0 ? (CUTOFFS[i - 1] as [(typeof CUTOFFS)[0][0], (typeof CUTOFFS)[0][1]])[0] : 1;
    if (absDiff < cutoff) {
      return rtf.format(Math.round(diffSec / prevCutoff), unit);
    }
  }

  return new Intl.DateTimeFormat("en", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
}

export function formatAbsoluteDate(dateStr: string): string {
  return new Intl.DateTimeFormat("en", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(dateStr));
}
